import { OPTION_INSTRUMENT_TYPE_CODES } from '../constants';

export function isOptionSymbol(
  instrumentTypeCode: string | number | null
): boolean {
  return instrumentTypeCode
    ? OPTION_INSTRUMENT_TYPE_CODES.includes(instrumentTypeCode.toString())
    : false;
}
